import React from "react";
import { Form, Input, DatePicker, Row, Col } from "antd";
import dayjs from "dayjs";

export interface TopDonorFormValues {
  fullName: string;
  description: string;
  startDate?: any;
  endDate?: any;
}

interface TopDonorFormProps {
  form: any;
}

export default function TopDonorForm({
  form,
}: TopDonorFormProps): React.ReactElement {
  return (
    <Form form={form} layout="vertical" autoComplete="off">
      <h3 style={{ marginBottom: 24, fontWeight: 600 }}>Add Top Donor</h3>

      {/* Full Name */}
      <Form.Item
        label="Full Name"
        name="name"
        rules={[{ required: true, message: "Full name is required" }]}
      >
        <Input placeholder="Type here" />
      </Form.Item>

      {/* Description */}
      <Form.Item
        label="Description"
        name="description"
        rules={[{ required: true, message: "Description is required" }]}
      >
        <Input.TextArea
          placeholder="Type here"
          rows={4}
          showCount
          maxLength={100}
        />
      </Form.Item>

      {/* Dates */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: true, message: "Start Date is required" }]}
          >
            <DatePicker
              placeholder="Select date"
              style={{ width: "100%" }}
              format="MMM DD, YYYY"
              disabledDate={(current) =>
                current && current.isBefore(dayjs().startOf("day"))
              }
              onChange={() => {
                const endDate = form.getFieldValue("endDate");
                const startDate = form.getFieldValue("startDate");
                if (
                  endDate &&
                  startDate &&
                  endDate.isBefore(startDate, "day")
                ) {
                  form.setFieldsValue({ endDate: null });
                }
                form.validateFields(["endDate"]);
              }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="End Date"
            name="endDate"
            rules={[
              { required: true, message: "End Date is required" },
              {
                validator: (_, value) => {
                  const startDate = form.getFieldValue("startDate");
                  if (
                    value &&
                    startDate &&
                    dayjs(value).isBefore(dayjs(startDate), "day")
                  ) {
                    return Promise.reject(
                      new Error("End Date must be after Start Date"),
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <DatePicker
              placeholder="Select date"
              style={{ width: "100%" }}
              format="MMM DD, YYYY"
              disabledDate={(current) => {
                const startDate = form.getFieldValue("startDate");
                if (current && current.isBefore(dayjs().startOf("day"))) {
                  return true;
                }
                if (
                  startDate &&
                  current &&
                  current.isBefore(startDate, "day")
                ) {
                  return true;
                }
                return false;
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
